import './select.styl';

import React from 'react';
import Icon from '../icon/Icon';

const Select = ({children}) =>
  <div className="select">
    <div className="select__select">
      {children}
    </div>
    <div className="select__icon">
      <Icon name="arrow-down" />
    </div>
  </div>;

export default Select;



// WEBPACK FOOTER //
// ./src/client/components/select/Select.js